import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { id } from 'date-fns/locale';


const styles = theme => ({
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '25%',
    paddingTop: '20px',
    paddingBottom: '20px',
    maxHeight: 'max-content',
    // marginTop: '20px',
    // padding: '15px',
  },
  text: {
    color: '#537ccd',
    textAlign: 'center',
    minWidth: '62px',
  },
  boldText: {
    color: '#537ccd',
    // fontWeight: 'bold',
    padding: '20px',
    fontSize: '2.7rem',
    whiteSpace: 'nowrap',
  },
  details: {
    paddingBottom: '0px',
    borderBottom: 'solid 1px rgb(224, 224, 224)',
  },
  details2: {
    padding: '15px',
    paddingBottom: '0px',
  },
  detailsTitle: {
    marginBottom: '10px',
  },
  rows: {
    display: 'flex',
  },
  item: {
    marginRight: 'auto',
    fontWeight: '300',
    fontSize: '0.9rem',
  },
});

const minuteToHour = (m) => {
  if (typeof m === 'string' && m.length >= 2) {
    return m;
  }

  const signal = m < 0 ? '-' : '';

  if (m < 0) {
    m *= -1;
  }

  if (m !== 0) {
    const hours = Math.floor(m / 60);
    let minutes = m % 60;
    if (minutes < 9) {
      minutes = `0${minutes}`;
    }
    return `${signal + hours}h ${minutes}m`;
  }
  return '0h';
};

const minuteToHourInitial = (m) => {
  if (typeof m === 'string' && m.length >= 2) {
    return m;
  }

  const signal = m < 0 ? '-' : '';

  if (m < 0) {
    m *= -1;
  }

  if (m !== 0) {
    const hours = Math.floor(m / 60);
    let minutes = m % 60;
    if (minutes < 9) {
      minutes = `0${minutes}`;
    }
    return `${signal + hours}:${minutes}`;
  }
  return '00:00';
};

const formatDate = (date) => {
  const dataOriginal = date;
  const dataObjeto = new Date(dataOriginal);
  const dia = String(dataObjeto.getDate()).padStart(2, '0');
  const mes = String(dataObjeto.getMonth() + 1).padStart(2, '0');
  const ano = dataObjeto.getFullYear();
  const dataFormatada = `${dia}/${mes}/${ano}`;
  return dataFormatada
}

const discountHours = (bank) => {
  try {
    let discount = 0
    if (bank.totalCalculatedBankHours) {
      bank.totalCalculatedBankHours.detailed.forEach(element => {
        if (element.paid != '00:00') {
          const partes = element.paid.split(' ');
          const horas = parseInt(partes[0]);
          const minutos = parseInt(partes[1]);
          const calculatedMinutes = horas * 60 + minutos;
          discount = discount + calculatedMinutes
        }
      })
    }
    return discount
  } catch (error) {
    console.log(error)
  }
}


const BankOfHoursDetails = ({
  classes,
  bank,
}) => (
  <React.Fragment>
    <Paper elevation={2} className={classes.container}>
      <div style={{ marginBottom: '10px' }}>
        <span
          style={{
            textAlign: 'center',
            marginRight: 'auto',
            marginLeft: 'auto',
            paddingTop: '20px',
          }}
        >
          Acumulado Total
        </span>

        <Typography variant="h5" className={classes.boldText}>
          {/* 2h23min */}
          {bank.global ? minuteToHour(bank.global.bankHoursBalanceTotal) : '0h'}
        </Typography>

        {
          bank.global && bank.global.dtStart ?
            <span
              style={{
                textAlign: 'center',
                marginRight: 'auto',
                marginLeft: 'auto',
                fontSize: '14px',
              }}
            /> : null
        }

      </div>

      <div className={classes.details2}>
        <span>Informações</span>
        <div className={classes.rows} style={{ marginTop: '10px' }}>
          <span className={classes.item} style={{ marginBottom: '5px' }}>Início</span>
          <span className={classes.text}>{bank.global && formatDate(bank.global.dtStart)}</span>
        </div>

        <div className={classes.rows} style={{ marginBottom: '5px' }}>
          <span className={classes.item}>Término</span>
          <span className={classes.text}>{bank.global && formatDate(bank.global.dtEnd)}</span>
        </div>
        <div className={classes.rows} >
          <span className={classes.item}>Valor Inicial </span>
          <span className={classes.text}>{bank.global && bank.global.initialValue ? minuteToHourInitial(bank.global.initialValue) : '00:00'}</span>

        </div>
        <div className={classes.rows} >
          <span className={classes.item}>Valor Abatido  </span>
          <span className={classes.text}>{bank.totalCalculatedBankHours ? minuteToHourInitial(discountHours(bank)) : '00:00'}</span>
        </div>
      </div>
    </Paper>
  </React.Fragment>
);

export default withStyles(styles)(BankOfHoursDetails);

